<template>
    <BaseModal
        :id="'confirmation-fields-modal'"
        :title="title"
        :message="'You are making updates to various rooms. Specify if you wish to make updates to the following items'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-md-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="[]"
                  :for_update="false"
                />
                <div v-if="form_data.room_type_id">
                    <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray;">
                        <span><img src="/assets/img/svg/information.svg" alt="CustomDescription" style="width: 15px;"></span>
                        <span style="margin-left: 5px;">As you want to edit the room type, confirm the data to update according to the room type</span>
                    </h6>
                    
                    <div class="p-0 formdynamic__item col-md-12" style="margin-top: 0px;">
                        <div class="formdynamic__item__field">
                            <label for="Default daily task:" class="modal-label">Default daily task: </label>
                            <span class="custom-control custom-checkbox">
                                <input id="ref0def_daily_task" type="checkbox" class="custom-control-input" value="default_daily_task" v-model="form_data.confirmation_fields">
                                <label for="ref0def_daily_task" class="custom-control-label ml-2"></label>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Confirm`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import FormResources from './form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'

export default {
  name: "FieldsConfirmationModal",

    props: [
        "title",
        "notyf",
        "breadcrumb",
        "form_data"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
            form_format: FormResources.confirmation_form_format,
            form_format_2: FormResources.confirmation_form_format_2,
        }
    },

    watch: {
        async 'form_data.room_type_id' (val) {
            this.form_data.confirmation_fields.splice(this.form_data.confirmation_fields.findIndex(item => item == 'default_daily_task'), 1)
            if(val) {
                this.form_data.confirmation_fields.push('default_daily_task')
            }
        }
    },

    methods: {

        form_submit()
        {
            if(!this.form_data.room_type_id)
            {
                let found_index = this.form_data.confirmation_fields.findIndex(item => item == 'default_daily_task')

                if(found_index > -1)
                {
                    this.form_data.confirmation_fields.splice(found_index, 1)
                }
            }
            
            this.$emit('formSubmit', true)
        },

    },

  mounted() {},

};
</script>